// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  // base_url_api: 'http://api.gestaoCondominio.local/',
  // base_url_api: 'http://127.0.0.1:8000/',//Minha máquina pelo localhost12
  base_url_api: 'http://localhost:8080/habitApp/public/',//Zeus pelo localhost
  // base_url_api: 'http://192.168.1.15:8080/',//Minha máquina pelo IP
  // base_url_api: 'http://192.168.0.111/habit-app/backend/public/',//Minha máquina pelo wamp
  // base_url_api: 'http://192.168.1.39/habit-app/backend/public/',//Minha máquina pelo wamp
  // base_url_api:'http://192.168.10.108/habit-app/backend/public/',//Minha máquina em casa pelo wamp
  // base_url_api: 'http://192.168.1.35/gestao-condominio-backend/public/',//HADES
  // base_url_api: 'https://apps2.mrn.com.br:8180/habit-app/backend/public/',//Base :MRN;
  // base_url_api: 'https://api2.mrn.com.br:8180/backend_habitapp/public/',//Base :MRN Produção;

  home_route:'gestao-condominio/home',
  login_route:'insti/login', 
  logout_route:'insti/logout',
  print_route:'print',//Minha máquina
  // print_route:'habit-app/print',//Base da MRN
  


  // export_route:'http://127.0.0.1:8000/downloadExcel',//Minha máquina pelo localhost
  export_route: 'http://localhost:8080/habitApp/public/downloadExcel',//Zeus pelo localhost
  // export_route:'http://192.168.10.109/habit-app/backend/public/downloadExcel',//Minha máquina em casa pelo IP
  // export_route:'http://192.168.1.39/habit-app/backend/public/downloadExcel',//Minha máquina pelo IP
  // export_route:'http://192.168.1.35/gestao-condominio-backend/public/downloadExcel',//HADES
  // export_route:'https://apps2.mrn.com.br:8180/habit-app/backend/public/downloadExcel',//Base MRN
  // export_route:'https://api2.mrn.com.br:8180/backend_habitapp/public/downloadExcel',//Base MRN Produção
};
